<template>
  <BootstrapDialog
    title="修改班级"
    ref="dialog"
    size="lg"
    @afterClose="afterClose()"
  >
    <template v-slot:body>
      <div class="modal-body wrapper-lg" style="width:100%">
        <div class="row">
          <div class="col-sm-8 col-sm-offset-2">
            <form role="form">
              <div class="form-group">
                <label><span style="color: red"></span>注册批次</label>
                <BootstrapCombobox
                  :data="zcpcList"
                  text-field="mc"
                  value-field="id"
                  v-model="model.zcpcId"
                  placeholder="-注册批次筛选-"
                  :formatOption="(item) => item.mc"
                ></BootstrapCombobox>
              </div>
              <div class="form-group">
                <label><span style="color: red">*</span>班级名称</label>
                <input
                  type="text"
                  name="bjmc"
                  v-model="model.bjmc"
                  v-validate="{ required: true, max: 200 }"
                  data-vv-as="班级名称"
                  class="form-control"
                  placeholder=""
                />
                <span class="error_validate_msg"
                  ><em>{{ errors.first("bjmc") }}</em></span
                >
              </div>
              <div class="form-group">
                <label><span style="color: red">*</span>主考学校</label>
                <BootstrapCombobox
                  name="zkxxId"
                  :data="zkxxList"
                  v-validate="{ required: true }"
                  text-field="jgmc"
                  value-field="id"
                  v-model="model.zkxxId"
                  data-vv-as="主考学校"
                  placeholder="-主考学校筛选-"
                  :formatOption="(item) => item.jgdm + '-' + item.jgmc"
                ></BootstrapCombobox>
                <span class="error_validate_msg"
                  ><em>{{ errors.first("zkxxId") }}</em></span
                >
              </div>
              <div class="form-group">
                <label><span style="color: red"></span>助学机构</label>
                <BootstrapCombobox
                  :data="zxjgList"
                  text-field="jgmc"
                  value-field="id"
                  v-model="model.zxjgId"
                  placeholder="-助学机构筛选-"
                  :formatOption="(item) => item.jgdm + '-' + item.jgmc"
                ></BootstrapCombobox>
              </div>

              <div class="form-group">
                <label><span style="color: red"></span>专业层次</label>
                <select
                  class="form-control"
                  v-model="model.zycc"
                  v-validate="{ required: true }"
                  data-vv-as="专业层次"
                  name="zycc"
                >
                  <option value="">-请选择-</option>
                  <option value="A">专科</option>
                  <option value="B">本科</option>
                  <option value="C">高起本</option>
                </select>
              </div>
              <div class="form-group">
                <label><span style="color: red"></span>专业</label>
                <BootstrapCombobox
                  :data="zyList"
                  text-field="mc"
                  value-field="id"
                  v-model="model.zyId"
                  placeholder="-报考专业筛选-"
                  :formatOption="(item) => item.xmbh + '-' + item.mc"
                ></BootstrapCombobox>
              </div>
              <div class="form-group">
                <label><span style="color: red"></span>班主任</label>
                <BootstrapCombobox
                  :data="bzrList"
                  text-field="xm"
                  value-field="id"
                  v-model="model.bzrId"
                  placeholder="-班主任筛选-"
                  :formatOption="(item) => item.xm"
                ></BootstrapCombobox>
              </div>
              <div class="form-group">
                <label><span style="color: red"></span>状态</label>
                <select
                  class="form-control"
                  v-model="model.zt"
                  v-validate="{ required: true }"
                  data-vv-as="状态"
                  name="zt"
                >
                  <option value="">-请选择-</option>
                  <option value="OK">启用</option>
                  <option value="BLOCK">禁止</option>
                </select>
              </div>
              <div class="form-group">
                <label><span style="color: red">*</span>班级编制</label>
                <input
                  type="number"
                  name="bjbz"
                  v-model="model.bjbz"
                  v-validate="{ required: true, max: 6 }"
                  data-vv-as="班级编制"
                  class="form-control"
                  placeholder=""
                />
                <span class="error_validate_msg"
                  ><em>{{ errors.first("bjbz") }}</em></span
                >
              </div>
            </form>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <button class="btn btn-primary" type="button" @click="save()">
        保存
      </button>
      <button
        style="margin-left:10px"
        class="btn btn-default"
        type="button"
        @click="close()"
      >
        关闭
      </button>
    </template>
  </BootstrapDialog>
</template>
<script>
export default {
  name: "BjEdit",
  components: {},
  data: function() {
    return {
      zkxxList: [],
      zxjgList: [],
      zcpcList: [],
      zyList: [],
      bzrList: [],
      model: {
        bjmc: "",
        zkxxId: "",
        zxjgId: "",
        zycc: "",
        zyId: "",
        bzrId: "",
      },
    };
  },
  methods: {
    reset: function() {
      this.model = {
        id: "",
        bjmc: "",
        zkxxId: "",
        zxjgId: "",
        zycc: "",
        zyId: "",
        bzrId: "",
        bjbz: "",
        zt: "",
        zcpcId: "",
      };
    },

    async open(params) {
      this.model.id = params.id;

      let res = await this.$http.post("/htgl/sys/bj/getOrg", { jglx: "ZKXX" });
      if (res.data) {
        this.zkxxList = res.data;
      }
      res = await this.$http.post("/htgl/sys/bj/getOrg", { jglx: "ZXJG" });
      if (res.data) {
        this.zxjgList = res.data;
      }

      res = await this.$http.post("/htgl/inf/zcpc/getZcpc", {});
      if (res.data) {
        this.zcpcList = res.data;
      }

      res = await this.$http.post("/htgl/biz/zypx/bm/hqByPc");
      if (res.data) {
        this.zyList = res.data;
      }
      //班主任
      res = await this.$http.post("/htgl/sys/bj/yhlb", { jsdm: "HEADMASTER" });
      if (res.data) {
        this.bzrList = res.data;
      }
      res = await this.$http.post("/htgl/sys/bj/hq", { id: this.model.id });
      if (res.data) {
        this.model.bjmc = res.data.bjmc;
        this.model.zkxxId = res.data.zkxxId;
        this.model.zxjgId = res.data.zxjgId;
        this.model.zycc = res.data.zycc;
        this.model.zyId = res.data.zyId;
        this.model.bzrId = res.data.bzrId;
        this.model.bjbz = res.data.bjbz;
        this.model.zt = res.data.zt;
        this.model.zcpcId = res.data.zcpcId;
      }
      this.$refs.dialog.open();
    },
    close: function() {
      this.$refs.dialog.close();
    },
    afterClose: function() {
      this.$validator.reset();
      this.reset();
    },
    save: function() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          //如果表单校验通过才可以保存
          this.$http.post("/htgl/sys/bj/xg", this.model).then((res) => {
            if (res.data == true) {
              this.$success("操作成功", () => {
                this.close();
                this.$parent.load(); //刷新列表
              });
            }
          });
        }
      });
    },
  },
};
</script>
